import { Dispatch, SetStateAction } from 'react'

import { Button, Dialog } from '@clientbase/clientbase-library'

type DialogReportProps = {
  setDialogRedirectReport: Dispatch<SetStateAction<boolean>>
  isOpenDialog: boolean
  loading: boolean
  handleOpenReportCloseDialog: () => void
}
const DialogReport = ({
  setDialogRedirectReport,
  isOpenDialog,
  loading,
  handleOpenReportCloseDialog
}: DialogReportProps) => {
  return (
    <Dialog
      icon="assignment"
      title={'Processando Relatório'}
      description={
        'Em instantes, seu relatório estará disponível na aba ”Relatórios", no menu superior da sua Base de Clientes.'
      }
      setIsOpenDialog={setDialogRedirectReport}
      isOpenDialog={isOpenDialog}
    >
      <Button
        variantButton="primary"
        autoFocus
        disabled={loading}
        onClick={handleOpenReportCloseDialog}
      >
        Ir para relatórios
      </Button>
    </Dialog>
  )
}

export default DialogReport
